export default __webpack_public_path__ + "static/notFound-546198202ee93dfb2d83bc3f275f9999.svg";